import { type QueryRef, useBackgroundQuery, useReadQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import type { AllIntermodalVehicleTypesQueryQuery } from '../../../gql/graphql';
import { getIntermodalVehicleTypeOptions } from '../../../use-cases/intermodal/utils/detailsUtils';
import { allIntermodalVehicleTypesQuery } from '../graphql/allIntermodalVehicleTypesQuery';

export interface AllIntermodalVehicleTypesQueryRefProps {
  vehicleTypesQueryRef: QueryRef<AllIntermodalVehicleTypesQueryQuery>;
}

export const useIntermodalVehicleTypesBackgroundQuery =
  (): QueryRef<AllIntermodalVehicleTypesQueryQuery> => {
    const [queryRef] = useBackgroundQuery(allIntermodalVehicleTypesQuery, {
      fetchPolicy: 'cache-first',
    });

    return queryRef;
  };

export const useAllIntermodalVehicleTypesAsOptions = (
  queryRef: QueryRef<AllIntermodalVehicleTypesQueryQuery>,
) => {
  const { data, error } = useReadQuery(queryRef);

  return useMemo(() => {
    return [
      getIntermodalVehicleTypeOptions(data?.viewer?.intermodalVehicleType.all.vehicleTypes ?? []),
      error,
    ] as const;
  }, [data, error]);
};
